'use client';

import { TeamGridItem } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import styles from './TeamValues.module.scss';
import Img from '../Img';
import PlayButton from '../Video/PlayButton';
import ReviewOverlay from './ReviewOverlay';
import deviceScreenSize, { ScreenSize } from '../../store/deviceScreenSize';
import CustomCursorWrapper from '../CustomCursor/CustomCursorWrapper';

interface ITeamValuesItemProps {
  item: TeamGridItem,
  changeActive: () => void;
  handleHover: (itemId: number | null) => void;
  activeId?: number | null;
}

const TeamValueItem = ({
  item, changeActive, handleHover, activeId,
}: ITeamValuesItemProps) => {
  const screenSize = useAtomValue(deviceScreenSize);
  const image = item.preview;

  const isHovered = activeId === item.id;
  const isDimed = !isHovered && !!activeId;
  const isMobile = screenSize < ScreenSize.TABLET_PORTRAIT;
  const name = item.name.split(' ')?.[0];

  return (
    isMobile ? (
      <ReviewOverlay
        item={item}
        close={() => null}
        isMobile
        preview={item.preview}
        activeItemId={activeId as number}
        currentItemId={item.id}
        handlePlayStart={() => handleHover(item.id)}
      />
    ) : (
      <div className={classNames(styles.teamValueItemWrapper, {
        [styles.hovered]: isHovered,
      })}
      >
        <button
          type='button'
          className={classNames(styles.teamValuesItem, {
            [styles.dimed]: isDimed,
          })}
          onMouseEnter={() => handleHover(item.id)}
          onMouseLeave={() => handleHover(null)}
          onClick={changeActive}
        >
          <CustomCursorWrapper
            view='primary'
            cursorText='play'
            className={styles.itemImageWrapper}
          >
            <Img
              src={image.url}
              width={image.width}
              height={image.height}
              alt={image.alternativeText || 'image'}
              className={styles.teamValuesItemImage}
            />
            <div className={classNames(styles.personData, styles.onItemData)}>
              <p className={classNames(styles.name, 'header5')}>{name || item.name}</p>
              <p className={classNames(styles.position, 'bodyExtraSmall')}>{`${item.position}`}</p>
            </div>
          </CustomCursorWrapper>
        </button>
        <div className={styles.playButtonWrapper}>
          <PlayButton
            isPlaying={false}
            onClick={changeActive}
            playButtonClassName={styles.playButton}
          />
        </div>
      </div>
    )
  );
};

export default TeamValueItem;
